import React, { forwardRef } from 'react';

const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.375rem',
    fontSize: '0.875rem',
    fontWeight: '500',
    lineHeight: '1.25rem',
    padding: '0.5rem 1rem', // default
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    border: 'none',
    outline: 'none'
};

const variants = {
    default: {
        backgroundColor: '#18181b', // slate-900
        color: '#ffffff',
    },
    destructive: {
        backgroundColor: '#ef4444', // red-500
        color: '#ffffff',
    },
    outline: {
        border: '1px solid #e5e7eb', // slate-200
        backgroundColor: 'transparent',
        color: '#0f172a', // slate-900
    },
    secondary: {
        backgroundColor: '#f1f5f9', // slate-100
        color: '#0f172a',
    },
    ghost: {
        backgroundColor: 'transparent',
        color: '#0f172a',
    },
    link: {
        backgroundColor: 'transparent',
        color: '#0f172a',
        textDecoration: 'underline',
    }
};

const sizes = {
    default: { height: '2.5rem', padding: '0.5rem 1rem' },
    sm: { height: '2.25rem', padding: '0 0.75rem', fontSize: '0.75rem' },
    lg: { height: '2.75rem', padding: '0 2rem' },
    icon: { height: '2.5rem', width: '2.5rem', padding: 0 }
};

const Button = forwardRef(({ className, variant = "default", size = "default", style, ...props }, ref) => {
    const variantStyle = variants[variant] || variants.default;
    const sizeStyle = sizes[size] || sizes.default;

    return (
        <button
            ref={ref}
            style={{
                ...baseStyle,
                ...variantStyle,
                ...sizeStyle,
                ...style
            }}
            {...props}
        />
    );
});
Button.displayName = "Button";

export { Button, baseStyle as buttonStyle };
